import { defineComponent as _defineComponent } from 'vue'
import { useCreatorShopRecentProducts } from "@/composables/creator-shop";
import { EXPERIMENTS_CREATOR_GIFT_GUIDES } from "@/utils/experiments/constants";


export default /*#__PURE__*/_defineComponent({
  __name: 'CreatorShopProductsTab',
  props: {
  profileId: { type: String, required: true },
  displayName: { type: String, required: true },
  isVisible: { type: Boolean, required: true, default: false },
  hasPosts: { type: Boolean, default: false },
  hasProductsSets: { type: Boolean, default: false },
},
  setup(__props) {

const props = __props;



const { searchTerm, showLoading, showError, productIds, onPaginate } = useCreatorShopRecentProducts(props.profileId);

return { __sfc: true,props, searchTerm, showLoading, showError, productIds, onPaginate, EXPERIMENTS_CREATOR_GIFT_GUIDES }
}

})